import workspaceQuery from 'graphql/queries/product/ProductsStockTransactionWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/ProductsStockTransactionListQuery.graphql';
import instanceQuery from 'graphql/queries/product/ProductsStockTransactionQuery.graphql';
import fragment from 'graphql/fragments/product/ProductsStockTransactionFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const ProductsStockTransaction = {
  type: 'StockTransaction',
  title: 'Stock Transactions',
  formTitle: 'Stock Transaction',
  formUrl: '/Products/ProductsStockTransaction/Details/',
  workspaceUrl: '/Products/ProductsStockTransaction/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentReference',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_TRANSACTIONS',
  operations: ALLOW_VIEW,
};

export default ProductsStockTransaction;
